var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":_vm.strings.community.title}},[_vm._v(_vm._s(_vm.strings.community.header))]),_c('QrFab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }